var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fm-table-new',{attrs:{"size":"small","auto-height":"","stripe":false,"full":"","columns":_vm.columns,"data-list":_vm.dataList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }